import { render, staticRenderFns } from "./ShowUpcomingDates.vue?vue&type=template&id=45430ba7&"
import script from "./ShowUpcomingDates.vue?vue&type=script&lang=ts&"
export * from "./ShowUpcomingDates.vue?vue&type=script&lang=ts&"
import style0 from "./ShowUpcomingDates.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ShowsCalendar: require('/tmp/build_71ad00c4/src/components/shows/Calendar.vue').default,Button: require('/tmp/build_71ad00c4/src/components/button/Button.vue').default,ShowsDateListItemSkeleton: require('/tmp/build_71ad00c4/src/components/shows/DateListItemSkeleton.vue').default,ShowsDateListItem: require('/tmp/build_71ad00c4/src/components/shows/DateListItem.vue').default,Modal: require('/tmp/build_71ad00c4/src/components/modal/Modal.vue').default,BlockWrapper: require('/tmp/build_71ad00c4/src/components/block/BlockWrapper.vue').default})
